import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useState } from 'react';

function useInquiryCommentForm(inquiryId: string) {
  const toast = useToast();
  const [content, setContent] = useState<string>('');
  const [fileUrls, setFileUrls] = useState<string[]>([]);
  const { push } = useFlow();
  const handleCreateComment = () => {
    if (content.length === 0) {
      toast.error('내용을 입력해주세요.');
      return;
    }
    push('InquiryCommentModal', { inquiryId, content, fileUrls });
  };
  return {
    content,
    setContent,
    fileUrls,
    setFileUrls,
    handleCreateComment,
  };
}

export default useInquiryCommentForm;
